import { render, staticRenderFns } from "./website_content.vue?vue&type=template&id=0a8c956c&"
import script from "./website_content.vue?vue&type=script&lang=js&"
export * from "./website_content.vue?vue&type=script&lang=js&"
import style0 from "./website_content.vue?vue&type=style&index=0&id=0a8c956c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports